import moment from "moment";
import { CnCOrderResponse } from "../types/api";

export const filterDeliveredOrders = (
  finishedOrders: CnCOrderResponse[],
  sinceDays?: number,
) => {
  const cutoff = sinceDays != null ? moment().subtract(sinceDays, "days") : null;
  return finishedOrders.filter(
    (order: any) =>
      order.userAddressResponse &&
      order.status === "TAKEN" &&
      order.userDeliveryResponse != null &&
      (cutoff == null || moment(order.created).isAfter(cutoff)),
  );
};
